/**
 * Decode JWT payload (no verification; used only for reading exp for refresh timing).
 * Returns exp (Unix seconds) or null if missing/invalid.
 */
export function getAccessTokenExp(accessToken: string): number | null {
  try {
    const parts = accessToken.split(".")
    if (parts.length !== 3) return null
    const payload = parts[1]
    if (!payload) return null
    const decoded = JSON.parse(
      atob(payload.replace(/-/g, "+").replace(/_/g, "/"))
    ) as { exp?: number }
    if (typeof decoded.exp !== "number") return null
    return decoded.exp
  } catch {
    return null
  }
}
